import { render, staticRenderFns } from "./home-slider-item.component.vue?vue&type=template&id=07ce37e2&"
import script from "./home-slider-item.component.vue?vue&type=script&lang=js&"
export * from "./home-slider-item.component.vue?vue&type=script&lang=js&"
import style0 from "./home-slider-item.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports